<div class="mb-2" [ngClass]="{ 'd-flex gap-2 align-items-center': tooltip }">
  <label *ngIf="type === 'text'" [htmlFor]="for" class="label" [ngClass]="cssClasses" [class.has-tooltip]="tooltip">{{
    label
  }}</label>
  <label
    *ngIf="type === 'html'"
    [htmlFor]="for"
    class="label"
    [ngClass]="cssClasses"
    [class.has-tooltip]="tooltip"
    [innerHTML]="label"
  ></label>
  <broker-tooltip-svg *ngIf="tooltip" [matTooltip]="tooltip"></broker-tooltip-svg>
</div>
